var popover = {};

popover.init = function ($root) {
    $("#app-content").find('[data-toggle="popover"]').each(function() {

    var $popoverInitial = $('[idref=' + $(this).attr('id')+']', $root);
    $(this).qtip({
        // prerender: true,
        show: 'click',
        hide: {
            event: 'unfocus'
        },
        content: {
            text: $popoverInitial
        },
        events: {
            /*render: function(event, api) {
                var elem = api.elements.tip;
            }
            ,*/
            visible: function() {
                popover.retina();
            }
        },
        position: {
            target: $(this),
            container: $('body'),
            viewport: $('body'),
            adjust: {
                x: -15,
                y: 0,
                method: 'shift'
            }
        },
        style: {
            /*tip: true,*/
            classes: 'count-down-bubble',
            tip: {
                corner: true,
                width: 12,
                height:12
            }
        }
    });
  });

  $(window).on('resize',function(e) {
      $("#app-content").find('[data-toggle="popover"]').qtip('reposition');
	});
}

popover.retina = function () {
	pap.retinaLoadInContext($('body'));
}

popover.destroyAll = function () {
  $("#app-content").find('[data-toggle="popover"]').qtip('destroy', true);
}

popover.hide = function () {
  $("#app-content").find('[data-toggle="popover"]').qtip('toggle', false);
}
